import styled from "styled-components"
import { mobile, mobilePortrait, tablet } from "../../Responsive"

export const Container = styled.div`
    background-color: ${({ theme }) => theme.body};
`

export const Wrapper = styled.div`
    margin-top: 100px;
    min-height: 85vh;
    padding: 50px 0px;
    display: flex;
    align-items: center;
    justify-content: center;

    ${tablet({ marginTop: "80px"})}
    ${mobile({ marginTop: "60px", padding: "10px"})}
    ${mobilePortrait({ marginTop: "40px"})}
`

export const Form = styled.form`
    width: 80%;
    padding: 20px;
    border: 1.5px solid var(--secondary);
    border-radius: 10px;
    background-color: ${({ theme }) => theme.body};
    opacity: 0.8;

    ${mobile({ width: "90%", padding: "10px" })}
`

export const Title = styled.h1`
    font-size: var(--fontL);
    font-weight: 400;
`

export const StyledInputs = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-top: 30px;
`

export const FormItem = styled.div`
    width: 400px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 15px;
    margin-right: 20px;

    ${tablet({ width: "300px" })}
    ${tablet({ width: "250px" })}
`

export const StyledSelect = styled.select`
    width: 400px;
    color-scheme: ${({ theme }) => theme.name};
    height: 30px;
    border-radius: 5px;

    ${tablet({ width: "300px" })}
    ${tablet({ width: "250px" })}
`

export const StyledOption = styled.option``

export const StyledLabel = styled.label`
    margin-bottom: 5px;
    color: var(--${props => props.color});

    ${({ color }) => color === "secondary" && "font-weight: 600;"};
`

export const StyledInput = styled.input`
    background-color: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    font-size: var(--fontS);
    border: none;
    border-bottom: 1px solid var(--primary);
    border-radius: 5px;
    height: 30px;

    ::placeholder{
        color: ${({ theme }) => theme.text};
    }

    :focus{
        border-bottom: 1px solid var(--secondary);
        outline: none;
    }
`

export const Upload = styled.div`
    width: 400px;
    display: flex;
    align-items: center;

    ${tablet({ width: "300px" })}
    ${tablet({ width: "250px" })}
`

export const UpdateImage = styled.img`
    width: 100px;
    height: 100px;
    border-radius: 10px;
    object-fit: cover;
    margin-right: 20px;
`

export const UploadIcon = styled.div`
    cursor: pointer;
    color: var(--secondary);
`

export const Message = styled.div`
    margin-top: 20px;
    color: var(--secondary);
    font-weight: 600;
`
